export default "__VITE_ASSET__CXOvgUtp__"